<script setup lang="ts">
import { StrapiBlocks } from "vue-strapi-blocks-renderer";

useHead({
  title: "Press",
});

const { data, error } = await useFetch<Press[]>("/api/press");

const backgroundImage = (pressItem: Press) => {
  return pressItem.images[0]?.url ? `url(${composeImageUrl(pressItem.images[0]?.url)})` : "";
};

onMounted(() => {
  
});
</script>
<template>
  <div class="content">
    <Breadcumb :title="'Press'" :subtitle="'What says about me.'" :items="[{ text: 'Home', href: '/' }]" :to="{ text: 'Press', href: '/press' }" />
    <!-- Block text section start  -->

    <div class="xboot-standard-row gray-bg">
      <div class="container">
        <div class="row">
          <div class="blog-masonry masonry">
            <PressCard class="col-lg-4 col-md-6" v-for="press in data" :key="press.id" :press="press" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.press-item {
  position: relative;
  background-color: var(--background-color);
  border: 1px solid var(--heading-color);
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s ease 0s;
  overflow: hidden;
}

.press-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: inherit;
  background-position: 0% 20%;
  background-size: cover;
  transform: scale(1);
  transform-origin: center center;
  z-index: 1;
  transition: all 0.3s ease 0s;
}

.press-item p {
  position: relative;
  z-index: 2;
  font-size: 1.5rem;
  color: var(--title-color);
  padding: 0.5rem;
  margin: 0;
  transition: all 0.3s ease 0s;
}

.press-item:hover {
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  transition: all 0.3s ease 0s;
}

.press-item:hover::before {
  transform: scale(10);
  filter: blur(3px);
  transition: all 0.3s ease 0s;
}
</style>
